import { render, staticRenderFns } from "./AxSwitchButton.vue?vue&type=template&id=e98a80e2&scoped=true"
import script from "./AxSwitchButton.vue?vue&type=script&lang=ts"
export * from "./AxSwitchButton.vue?vue&type=script&lang=ts"
import style0 from "./AxSwitchButton.vue?vue&type=style&index=0&id=e98a80e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98a80e2",
  null
  
)

export default component.exports